<template>
  <div>
    <v-layout>
      <v-flex xs12 sm12 md6 offset-md3 lg4 offset-lg4>
        <v-layout column v-if="user === null" align-center>
          <!-- <v-progress-circular style="margin-top:100px" color="red lighten-3" size="64" indeterminate ></v-progress-circular> -->
          <progress-q></progress-q>
        </v-layout>
        <v-card v-if="user !== null">
          <v-layout column align-center>
            <img
              :src="defaultAvatar"
              ref="avatar"
              class="avatar-img elevation-3"
            />
          </v-layout>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{ fullName }}</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md6 lg6>
                <label>{{ getString("La tua email") }}</label>
                <v-text-field
                  style="margin: 10px"
                  v-model="user.email"
                  :rules="emailRule"
                  solo
                  disabled
                  :label="getString('Inserisci la tua email')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6>
                <label>{{ getString("Il tuo telefono") }}</label>
                <v-text-field
                  style="margin: 10px"
                  v-model="user.phone"
                  solo
                  :label="getString('Inserisci il tuo telefono')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6>
                <label>{{ getString("Password") }}</label>
                <v-text-field
                  type="password"
                  aria-autocomplete="off"
                  style="margin: 10px"
                  v-model="pwd"
                  :rules="minLenghtRule"
                  solo
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6>
                <label>{{ getString("Conferma password") }}</label>
                <v-text-field
                  type="password"
                  aria-autocomplete="off"
                  style="margin: 10px"
                  v-model="cnfPwd"
                  :rules="pwdConfirmRule"
                  solo
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn flat color="orange" @click="show = !show">{{
              getString("Cambia immagine")
            }}</v-btn>
            <v-btn
              flat
              color="orange"
              :class="{ 'save-alert': saveAlert }"
              @click="setConfig"
              >{{ getString("Salva") }}</v-btn
            >
          </v-card-actions>
          <v-card-text v-show="isLoading">
            <v-progress-linear
              ref="fileUploadProgress"
              :value="updateProgressValue"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-flex>
      <my-upload
        ref="fileToUpload"
        noSquare
        @crop-success="cropSuccess"
        v-model="show"
        :width="500"
        :height="500"
        @src-file-set="sourceSet"
        :withCredentials="true"
        langType="it"
      ></my-upload>
    </v-layout>
  </div>
</template>

<script>
import Utils from "../../utils.js";
import ajax from "../../ajax.js";
import myUpload from "vue-image-crop-upload";
import ImageCompressor from "image-compressor.js";
import ProgressQ from "./ProgressQ";
var ut = new Utils();
export default {
  name: "Profile",
  components: {
    "my-upload": myUpload,
    "progress-q": ProgressQ,
  },
  mounted: function () {
    this.getConfig();
  },
  computed: {
    fullName: function () {
      return this.user.name + " " + this.user.surname;
    },
    pwdConfirmRule: function () {
      return [
        (v) => v === this.pwd || this.getString("Le password non coincidono"),
      ];
    },
    minLenghtRule: function () {
      return [
        (v) =>
          v === null ||
          ut.MinLengthValidate(v, 8) ||
          this.getString("Password troppo corta, almeno 8 caratteri"),
      ];
    },
    notEmpty: function () {
      return [(v) => !!v || this.getString("Campo richiesto")];
    },
    emailRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateEmail(v) || this.getString("Email non valida"),
      ];
    },
    numRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateNumber(v) || this.getString("Numero non valido"),
      ];
    },
    checkValues: function () {
      return (
        this.user.email !== null &&
        (this.pwd === null ||
          this.pwd === "" ||
          (this.pwd === this.cnfPwd && ut.MinLengthValidate(this.pwd, 8)))
      );
    },
    saveAlert: function () {
      let val =
        this.image != null ||
        this.user.email != this.oldEmail ||
        this.user.phone != this.oldPhone ||
        (this.pwd === this.cnfPwd && ut.MinLengthValidate(this.pwd, 8));
      if (val && !this.$store.state.modifying) {
        this.$store.commit("isModifying");
      }
      if (!val && this.$store.state.modifying) {
        this.$store.commit("notIsModifying");
      }
      return val;
    },
    defaultAvatar: function () {
      if (
        this.user.photo === null ||
        this.user.photo === "/images/u_placeholder.jpg" ||
        this.user.photo === "images/u_placeholder.jpg"
      ) {
        return "/../../../static/img/default-avatar.png";
      } else
        return (
          (this.user.photo.startsWith('http') ? this.user.photo : ajax.baseUrl() + this.user.photo) + "?t=" + new Date().getSeconds()
        );
    },
  },
  data: () => {
    return {
      h: null,
      isLoading: false,
      hidden: false,
      image: null,
      imageName: "",
      oldEmail: "",
      oldPhone: "",
      pwd: null,
      cnfPwd: null,
      user: null,
      updateProgressValue: 0,
      show: false,
    };
  },
  methods: {
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    getConfig: function () {
      let self = this;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/user/me/get", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.user = response.data.data;
          self.oldEmail = self.user.email;
          self.oldPhone = self.user.phone;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    cropSuccess(imgDataUrl, field) {
      this.$refs.avatar.src = imgDataUrl;
      this.image = ut.data2blob(
        imgDataUrl,
        ut.getFileExtension(this.imageName)
      );
    },
    sourceSet: function (name, type, size) {
      this.imageName = this.$refs.fileToUpload.$refs.fileinput.files[0].name;
    },
    setConfig: function () {
      if (this.checkValues) {
        let self = this;
        this.isLoading = true;
        var data = new FormData();
       // data.append("email", this.user.email);
        data.append("phone", this.user.phone);
        if (this.pwd !== null && this.pwd === this.cnfPwd)
          data.append("pwd", this.pwd);
        if (this.image === null) {
          ajax.axios
            .put(ajax.baseUrl() + "/admin/user/me/set", data, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + self.$store.getters.token,
              },
              onUploadProgress: function (progressEvent) {
                let p = parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
                self.updateProgressValue = p;
              }.bind(this),
              withCredentials: true,
            })
            .then(function (response) {
              ajax.validateToken(response.headers, self.$store);
              self.$emit("siteAlertSuccess", response.data.data.text);
              self.image = null;
              self.user = response.data.data.user;
              self.oldEmail = self.user.email;
              self.oldPhone = self.user.phone;
              (self.pwd = null), (self.cnfPwd = null);
              self.isLoading = false;
              self.updateProgressValue = 0;
            })
            .catch(function (error) {
              var auth = ajax.checkAuth(error, self.$store, self.$router);
              self.isLoading = false;
              self.updateProgressValue = 0;
              self.$emit(
                "siteAlert",
                auth
                  ? self.getString("Non hai l'autorizzazione")
                  : error.response.data.errorMessage
              );
            });
        } else {
          new ImageCompressor(this.image, {
            quality: 0.7,
            success(result) {
              data.append("files", result, self.imageName);
              ajax.axios
                .put(ajax.baseUrl() + "/admin/user/me/set", data, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + self.$store.getters.token,
                  },
                  onUploadProgress: function (progressEvent) {
                    let p = parseInt(
                      Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                      )
                    );
                    self.updateProgressValue = p;
                  }.bind(this),
                  withCredentials: true,
                })
                .then(function (response) {
                  ajax.validateToken(response.headers, self.$store);
                  self.$emit("siteAlertSuccess", response.data.data.text);
                  self.image = null;
                  self.user = response.data.data.user;
                  self.oldEmail = self.user.email;
                  self.oldPhone = self.user.phone;
                  self.isLoading = false;
                  self.updateProgressValue = 0;
                })
                .catch(function (error) {
                  var auth = ajax.checkAuth(error, self.$store, self.$router);
                  self.isLoading = false;
                  self.updateProgressValue = 0;
                  self.$emit(
                    "siteAlert",
                    auth
                      ? self.getString("Non hai l'autorizzazione")
                      : error.response.data.errorMessage
                  );
                });
            },
            error(e) {
              self.$emit(
                "siteAlert",
                self.getString("Errore nella compressione")
              );
            },
          });
        }
      } else {
        this.$emit("siteAlert", this.getString("Alcuni campi non validi"));
      }
    },
  },
};
</script>

<style scoped>
.avatar-img {
  margin-top: 10px;
  max-width: 30%;
  border-radius: 50%;
}

.save-alert {
  animation-name: saveAlertAnimation !important;
  animation-timing-function: linear !important;
  animation-duration: 1s !important;
  animation-iteration-count: infinite !important;
}
@keyframes saveAlertAnimation {
  0% {
    background-color: transparent;
  }

  50% {
    background-color: bisque;
  }
  100% {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Profile.vue